import { Outlet } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../styles/projects-layout.css";
import "../styles/inner-page.css";

const ProjectsLayout = () => {
    return (
        <div className="page-wrapper projects-layout inner-page-wrapper">
            <Header />
            <main className="projects-main">
                <Outlet />
            </main>
            <Footer />
        </div>
    )
}

export default ProjectsLayout
